import { z } from "zod";
import { ClientApplicationType } from "../../hooks/types";

export const deviceSlugSchema = z.enum(ClientApplicationType);
export const installationTypeSchema = z.enum(["store", "sideloading", "mdm"]);
